import {
  NBS_API_TRANS_COREG_LOOKUP_REQUEST,
  NBS_API_TRANS_COREG_LOOKUP_SUCCESS,
  NBS_API_TRANS_COREG_LOOKUP_FAILURE
} from '../../constants/actions';
import nbsApi from '../../assets/helpers/nbsApi';
import strings from '../../assets/localization';

function nbsApiTransCoregLookupRequest () {
  return { type: NBS_API_TRANS_COREG_LOOKUP_REQUEST };
}

function nbsApiTransCoregLookupSuccess (response) {
  return {
    type: NBS_API_TRANS_COREG_LOOKUP_SUCCESS,
    response
  };
}

function nbsApiTransCoregLookupError (error) {
  return {
    type: NBS_API_TRANS_COREG_LOOKUP_FAILURE,
    error: error.cause || error
  };
}

export function nbsApiTransCoregLookup (data) {
  const url = 'transCoregLookup';
  if (!data.language && strings.getLanguage()) {
    data.language = strings.getLanguage();
  }
  return dispatch => {
    dispatch(nbsApiTransCoregLookupRequest());
    return nbsApi(url, data)
      .then(response => dispatch(nbsApiTransCoregLookupSuccess(response)))
      .catch(error => dispatch(nbsApiTransCoregLookupError(error)));
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/transCoregLookup.js